<article class="course-grid m-2 px-2 pt-1" *ngIf="course.canAccess" (deferLoad)="course.renderOnPage = true;" >
  <ng-container *ngIf="course.renderOnPage">
    <div class="row" id="grid-row">
      <div class="col">
        <div class="mr-2 course-thumb">
          <a routerLink="/course/{{course.alias}}">
            <app-thumbnail-highlight [course]="course"></app-thumbnail-highlight>
            <img [src]="course.thumbnail_image_url" width="300" height="169" alt="Image for course {{ course.title }}" />
          </a>
        </div>
        <h4>
          <fa-icon *ngIf="cartService.IsItemInCart(course.netforum_course_id)" icon="shopping-cart" class="mr-2" title="This course is in your cart"></fa-icon>
          <a routerLink="/course/{{course.alias}}">{{ course.title }}<ng-container *ngIf="course.library=='WMC'"> (WMC)</ng-container></a>
        </h4>
        <h5 class="coursesubtitle" *ngIf="course.subtitle">{{ course.subtitle }}</h5>
        <h6>
          <app-course-author-list [authors]="course.authors" [link]="false" title="Show author biography"></app-course-author-list>
        </h6>
      </div>
    </div>
  </ng-container>
</article>
